module.exports = __webpack_public_path__ + "static/media/hackathon-of-humanoid-robots-2.7bdb1728.png";